// // src\components\page\ar-space\ArSpaceFilterBar\ArSpaceFilterBar.tsx

// 'use client';

// import React, { useEffect, useMemo, useRef, useState } from 'react';
// import { Tab } from '@/components/ui/tab/Tab';
// import { IconCancel, IconFilter, IconSearch, IconSortOutline } from '@/components/icons';
// import type { ArSpaceGroup, ArType, OrderBy } from '@/types/arSpace';
// import styles from './ArSpaceFilterBar.module.scss';
// import { useScrollDirection } from './useFilterScroll';

// type TabKind = 'all' | ArType;

// export type ArSpaceFilterBarFeatures = {
//   tabs?: boolean; // 全部/官方/個人
//   search?: boolean;
//   order?: boolean;
//   category?: boolean;
// };

// const DEFAULT_FEATURES: Required<ArSpaceFilterBarFeatures> = {
//   tabs: true,
//   search: true,
//   order: true,
//   category: true,
// };

// const orderByText = (k: OrderBy) =>
//   k === 'letime'
//     ? '修改時間新→舊'
//     : k === 'crtime'
//       ? '依最新→舊'
//       : k === 'distance'
//         ? '依距離近→遠'
//         : '依熱門高→低';

// type CommonProps = {
//   /** 插拔式：控制要顯示哪些 filter */
//   features?: ArSpaceFilterBarFeatures;

//   /** Search */
//   keyword?: string;
//   onKeywordChange?: (value: string) => void;

//   /** Order */
//   orderBy?: OrderBy;
//   orderByLabel?: string;
//   onOrder?: (key: OrderBy) => void;

//   /** ✅ 由外層注入：要求定位（距離排序用） */
//   ensureUserLocation?: () => void;

//   /** Category */
//   groupId?: string;
//   onGroup?: (id: string) => void;
//   arspaceGroups?: ArSpaceGroup[];

//   /** 手機版搜尋第二次點擊「搜尋」時，通知外層立即觸發搜尋 */
//   onMobileSearchConfirm?: () => void;

//   /** 預設是否展開（手機） */
//   defaultMobileOpen?: boolean;

//   setClass?: string;
// };

// type PropsWithTabs = CommonProps & {
//   features?: ArSpaceFilterBarFeatures & { tabs: true };
//   tab: TabKind;
//   onTab: (next: TabKind) => void;
// };

// type PropsWithoutTabs = CommonProps & {
//   features?: (ArSpaceFilterBarFeatures & { tabs?: false }) | undefined;
//   tab?: never;
//   onTab?: never;
// };

// type Props = PropsWithTabs | PropsWithoutTabs;

// const ArSpaceFilterBar: React.FC<Props> = (props) => {
//   const {
//     features,
//     keyword = '',
//     onKeywordChange,
//     orderBy = 'crtime',
//     orderByLabel,
//     onOrder,
//     ensureUserLocation,
//     groupId = 'all',
//     onGroup,
//     arspaceGroups = [],
//     onMobileSearchConfirm,
//     defaultMobileOpen = false,
//     setClass,
//   } = props;

//   const feat = useMemo(() => ({ ...DEFAULT_FEATURES, ...(features ?? {}) }), [features]);

//   // =========================
//   // 手機：filter 展開/收合
//   // =========================
//   const [mobileFilterOpen, setMobileFilterOpen] = useState<boolean>(defaultMobileOpen);

//   useEffect(() => {
//     if (typeof window === 'undefined') return;

//     const handler = (evt: Event) => {
//       const e = evt as CustomEvent<{ action?: 'toggle' | 'open' | 'close' }>;
//       const action = e.detail?.action ?? 'toggle';

//       setMobileFilterOpen((prev) => {
//         if (action === 'open') return true;
//         if (action === 'close') return false;
//         return !prev;
//       });
//     };

//     window.addEventListener('arspace-filter', handler as EventListener);
//     return () => window.removeEventListener('arspace-filter', handler as EventListener);
//   }, []);

//   // =========================
//   // ✅ 手機：搜尋 icon -> 展開 input（舊功能）
//   // =========================
//   const [mobileSearchOpen, setMobileSearchOpen] = useState(false);
//   const mobileInputRef = useRef<HTMLInputElement | null>(null);

//   const onMobileSearchClick = () => {
//     if (!onKeywordChange) return;
//     setMobileSearchOpen(true);

//     // 開啟後 focus
//     if (typeof window !== 'undefined') {
//       window.setTimeout(() => {
//         mobileInputRef.current?.focus();
//       }, 0);
//     }
//   };

//   const onMobileSearchClose = () => {
//     setMobileSearchOpen(false);
//   };

//   // 搜尋 icon 切換（桌機 input 用）
//   const hasKeyword = keyword.trim().length > 0;

//   // =========================
//   // dropdown 收合
//   // =========================
//   const [openOrderDropdown, setOpenOrderDropdown] = useState(false);
//   const [openGroupDropdown, setOpenGroupDropdown] = useState(false);
//   const orderWrapRef = useRef<HTMLDivElement | null>(null);
//   const groupWrapRef = useRef<HTMLDivElement | null>(null);

//   useEffect(() => {
//     const handleDocClick = (e: MouseEvent) => {
//       const target = e.target as Node;
//       if (openOrderDropdown && orderWrapRef.current && !orderWrapRef.current.contains(target)) {
//         setOpenOrderDropdown(false);
//       }
//       if (openGroupDropdown && groupWrapRef.current && !groupWrapRef.current.contains(target)) {
//         setOpenGroupDropdown(false);
//       }
//     };
//     const handleKey = (e: KeyboardEvent) => {
//       if (e.key === 'Escape') {
//         setOpenOrderDropdown(false);
//         setOpenGroupDropdown(false);
//         setMobileSearchOpen(false);
//       }
//     };
//     document.addEventListener('click', handleDocClick);
//     document.addEventListener('keydown', handleKey);
//     return () => {
//       document.removeEventListener('click', handleDocClick);
//       document.removeEventListener('keydown', handleKey);
//     };
//   }, [openOrderDropdown, openGroupDropdown]);

//   // =========================
//   // 滾動後 class 切換
//   // =========================
//   const { dir: scrollDir, scrollY } = useScrollDirection({ threshold: 4, initial: 'up' });

//   /** 手機＋桌機共用 wrapper class */
//   const filterWrapperClass = mobileFilterOpen ? '' : 'd-md-block';

//   const filterPanelClassName = [
//     filterWrapperClass,
//     styles.filterPanel,
//     mobileFilterOpen ? styles.filterPanelOpen : '',
//     // 邏輯判斷：
//     // 如果往下捲：直接給 scrollDown
//     // 如果往上捲：必須滿足「scrollY > 10」才給 scrollUp，否則不給 class (保持初始狀態)
//     scrollDir === 'down'
//       ? styles.filterPanelScrollDown
//       : scrollY > 10
//         ? styles.filterPanelScrollUp
//         : '',
//   ]
//     .filter(Boolean)
//     .join(' ');

//   const safeOrderLabel = orderByLabel ?? orderByText(orderBy);

//   // Tabs props（只有在 feat.tabs === true 時才會存在）
//   const tab = feat.tabs ? (props as PropsWithTabs).tab : undefined;
//   const onTab = feat.tabs ? (props as PropsWithTabs).onTab : undefined;

//   return (
//     <div className={`bg-white ${filterPanelClassName}`}>
//       <div className={setClass}>
//         {/* Tabs */}
//         {feat.tabs && tab && onTab && (
//           <section className="mb-5 d-flex align-items-center">
//             <Tab isActive={tab === 'all'} onClick={() => onTab('all')}>
//               全部
//             </Tab>
//             <Tab isActive={tab === 'branch'} onClick={() => onTab('branch')}>
//               官方
//             </Tab>
//             <Tab isActive={tab === 'ar_space'} onClick={() => onTab('ar_space')}>
//               個人
//             </Tab>
//           </section>
//         )}

//         <div className="position-relative">
//           <div className="d-flex flex-wrap bd-highlight align-items-stretch gap-3 mb-0">
//             {/* Search */}
//             {feat.search && (
//               <>
//                 {/* 桌機版搜尋 input */}
//                 <div className="position-relative flex-fill bd-highlight d-none d-md-block">
//                   <input
//                     className="form-control placeholder-md shadow-sm rounded-3 p-3"
//                     type="text"
//                     placeholder="請輸入關鍵字"
//                     value={keyword}
//                     onChange={(e) => onKeywordChange?.(e.target.value)}
//                   />
//                   <button
//                     type="button"
//                     className="position-absolute end-0 top-0 p-3"
//                     aria-label={hasKeyword ? '清除關鍵字' : '搜尋'}
//                     onClick={() => {
//                       if (!onKeywordChange) return;
//                       if (hasKeyword) onKeywordChange('');
//                       else onMobileSearchConfirm?.();
//                     }}
//                   >
//                     {hasKeyword ? <IconCancel /> : <IconSearch />}
//                   </button>
//                 </div>

//                 {/* 手機版搜尋 input */}
//                 <div className="d-md-none order-3">
//                   {!mobileSearchOpen && (
//                     <button
//                       type="button"
//                       className="form-control shadow-sm rounded-3 p-3 w-auto d-flex align-items-center justify-content-center"
//                       aria-label="搜尋"
//                       onClick={onMobileSearchClick}
//                     >
//                       <IconSearch width={16} />
//                     </button>
//                   )}

//                   {mobileSearchOpen && (
//                     <div className="position-absolute top-0 end-0 w-100" style={{ zIndex: 20 }}>
//                       <div className="position-relative">
//                         <input
//                           ref={mobileInputRef}
//                           className=" form-control placeholder-sm shadow-sm rounded-3 p-2"
//                           type="text"
//                           placeholder="請輸入關鍵字"
//                           value={keyword}
//                           onChange={(e) => onKeywordChange?.(e.target.value)}
//                           onKeyDown={(e) => {
//                             if (e.key === 'Enter') {
//                               onMobileSearchConfirm?.();
//                               setMobileSearchOpen(false);
//                             }
//                           }}
//                         />
//                         <button
//                           type="button"
//                           className="position-absolute top-0 end-0 p-2"
//                           aria-label="關閉搜尋"
//                           onClick={onMobileSearchClose}
//                           title="關閉"
//                         >
//                           <IconCancel />
//                         </button>
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               </>
//             )}

//             {/* Order */}
//             {feat.order && (
//               <div
//                 className="position-relative flex-grow-1 flex-md-grow-0 bd-highlight"
//                 ref={orderWrapRef}
//               >
//                 <button
//                   type="button"
//                   className="d-flex form-control shadow-sm rounded-3 p-2 p-md-3 align-items-center justify-content-between"
//                   aria-haspopup="menu"
//                   aria-expanded={openOrderDropdown}
//                   onClick={() => setOpenOrderDropdown((v) => !v)}
//                 >
//                   <span className="d-flex align-items-center">
//                     <IconSortOutline className="me-1" />
//                     {safeOrderLabel}
//                   </span>
//                   <span className="ms-2">▾</span>
//                 </button>

//                 {openOrderDropdown && (
//                   <ul
//                     role="menu"
//                     className="dropdown-menu show w-100 mt-1"
//                     style={{
//                       position: 'absolute',
//                       inset: 'auto auto 0 0',
//                       transform: 'translate3d(0, 100%, 0)',
//                     }}
//                   >
//                     {(['letime', 'crtime', 'distance', 'article_num'] as const).map((key) => (
//                       <li key={key}>
//                         <button
//                           type="button"
//                           role="menuitem"
//                           className="dropdown-item d-flex justify-content-between"
//                           onClick={() => {
//                             if (key === 'distance') ensureUserLocation?.();
//                             onOrder?.(key);
//                             setOpenOrderDropdown(false);
//                           }}
//                         >
//                           <span>{orderByText(key)}</span>
//                           {orderBy === key && <span>✓</span>}
//                         </button>
//                       </li>
//                     ))}
//                   </ul>
//                 )}
//               </div>
//             )}

//             {/* Category */}
//             {feat.category && arspaceGroups.length > 0 && (
//               <div
//                 className="position-relative flex-grow-1 flex-md-grow-0 bd-highlight"
//                 ref={groupWrapRef}
//               >
//                 <button
//                   type="button"
//                   className="d-flex form-control shadow-sm rounded-3 p-2 p-md-3 align-items-center justify-content-between"
//                   aria-haspopup="menu"
//                   aria-expanded={openGroupDropdown}
//                   onClick={() => setOpenGroupDropdown((v) => !v)}
//                 >
//                   <span className="d-flex align-items-center">
//                     <IconFilter width={16} className="me-2" />
//                     {groupId === 'all'
//                       ? '主題'
//                       : (arspaceGroups.find((g) => String(g.id) === groupId)?.name ?? groupId)}
//                   </span>
//                   <span className="ms-2">▾</span>
//                 </button>

//                 {openGroupDropdown && (
//                   <ul
//                     role="menu"
//                     className="dropdown-menu show w-100 mt-1"
//                     style={{
//                       position: 'absolute',
//                       inset: 'auto auto 0 0',
//                       transform: 'translate3d(0, 100%, 0)',
//                     }}
//                   >
//                     <li>
//                       <button
//                         type="button"
//                         role="menuitem"
//                         className="dropdown-item d-flex justify-content-between"
//                         onClick={() => {
//                           onGroup?.('all');
//                           setOpenGroupDropdown(false);
//                         }}
//                       >
//                         <span>不限主題</span>
//                         {groupId === 'all' && <span>✓</span>}
//                       </button>
//                     </li>

//                     {arspaceGroups.map((g) => (
//                       <li key={g.id}>
//                         <button
//                           type="button"
//                           role="menuitem"
//                           className="dropdown-item d-flex justify-content-between"
//                           onClick={() => {
//                             onGroup?.(String(g.id));
//                             setOpenGroupDropdown(false);
//                           }}
//                         >
//                           <span>{g.name}</span>
//                           {groupId === String(g.id) && <span>✓</span>}
//                         </button>
//                       </li>
//                     ))}
//                   </ul>
//                 )}
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ArSpaceFilterBar;

// src\components\page\ar-space\ArSpaceFilterBar\ArSpaceFilterBar.tsx

'use client';

import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Tab } from '@/components/ui/tab/Tab';
import { IconCancel, IconFilter, IconSearch, IconSortOutline } from '@/components/icons';
import type { ArSpaceGroup, ArType, OrderBy } from '@/types/arSpace';
import styles from './ArSpaceFilterBar.module.scss';
import { useScrollDirection } from '@/hooks/useScrollDirection';

type TabKind = 'all' | ArType;

export type ArSpaceFilterBarFeatures = {
  tabs?: boolean; // 全部/官方/個人
  search?: boolean;
  order?: boolean;
  category?: boolean;
};

const DEFAULT_FEATURES: Required<ArSpaceFilterBarFeatures> = {
  tabs: true,
  search: true,
  order: true,
  category: true,
};

const orderByText = (k: OrderBy) =>
  k === 'letime'
    ? '依最新→舊'
    : k === 'crtime'
      ? '建立時間新→舊'
      : k === 'distance'
        ? '依距離近→遠'
        : '依熱門高→低';

type CommonProps = {
  /** 插拔式：控制要顯示哪些 filter */
  features?: ArSpaceFilterBarFeatures;

  /** Search */
  keyword?: string;
  onKeywordChange?: (value: string) => void;

  /** Order */
  orderBy?: OrderBy;
  orderByLabel?: string;
  onOrder?: (key: OrderBy) => void;

  /** ✅ 由外層注入：要求定位（距離排序用） */
  ensureUserLocation?: () => void;

  /** Category */
  groupId?: string;
  onGroup?: (id: string) => void;
  arspaceGroups?: ArSpaceGroup[];

  /** 手機版搜尋第二次點擊「搜尋」時，通知外層立即觸發搜尋 */
  onMobileSearchConfirm?: () => void;

  /** 預設是否展開（手機） */
  defaultMobileOpen?: boolean;

  setClass?: string;

  allowCrtime?: boolean; //是否關閉建立最新到最舊
};

type PropsWithTabs = CommonProps & {
  features?: ArSpaceFilterBarFeatures & { tabs: true };
  tab: TabKind;
  onTab: (next: TabKind) => void;
};

type PropsWithoutTabs = CommonProps & {
  features?: (ArSpaceFilterBarFeatures & { tabs?: false }) | undefined;
  tab?: never;
  onTab?: never;
};

type Props = PropsWithTabs | PropsWithoutTabs;

const ArSpaceFilterBar: React.FC<Props> = (props) => {
  const {
    features,
    keyword = '',
    onKeywordChange,

    // ✅ 改成 letime 預設
    orderBy = 'letime',

    orderByLabel,
    onOrder,
    ensureUserLocation,
    groupId = 'all',
    onGroup,
    arspaceGroups = [],
    onMobileSearchConfirm,
    defaultMobileOpen = false,
    setClass,
    allowCrtime = false,
  } = props;

  const feat = useMemo(() => ({ ...DEFAULT_FEATURES, ...(features ?? {}) }), [features]);

  // =========================
  // 手機：filter 展開/收合
  // =========================
  const [mobileFilterOpen, setMobileFilterOpen] = useState<boolean>(defaultMobileOpen);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const handler = (evt: Event) => {
      const e = evt as CustomEvent<{ action?: 'toggle' | 'open' | 'close' }>;
      const action = e.detail?.action ?? 'toggle';

      setMobileFilterOpen((prev) => {
        if (action === 'open') return true;
        if (action === 'close') return false;
        return !prev;
      });
    };

    window.addEventListener('arspace-filter', handler as EventListener);
    return () => window.removeEventListener('arspace-filter', handler as EventListener);
  }, []);

  // =========================
  // ✅ 手機：搜尋 icon -> 展開 input
  // =========================
  const [mobileSearchOpen, setMobileSearchOpen] = useState(false);
  const mobileInputRef = useRef<HTMLInputElement | null>(null);

  const onMobileSearchClick = () => {
    if (!onKeywordChange) return;
    setMobileSearchOpen(true);

    if (typeof window !== 'undefined') {
      window.setTimeout(() => {
        mobileInputRef.current?.focus();
      }, 0);
    }
  };

  const onMobileSearchClose = () => {
    setMobileSearchOpen(false);
  };

  const hasKeyword = keyword.trim().length > 0;

  // =========================
  // dropdown 收合
  // =========================
  const [openOrderDropdown, setOpenOrderDropdown] = useState(false);
  const [openGroupDropdown, setOpenGroupDropdown] = useState(false);
  const orderWrapRef = useRef<HTMLDivElement | null>(null);
  const groupWrapRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleDocClick = (e: MouseEvent) => {
      const target = e.target as Node;
      if (openOrderDropdown && orderWrapRef.current && !orderWrapRef.current.contains(target)) {
        setOpenOrderDropdown(false);
      }
      if (openGroupDropdown && groupWrapRef.current && !groupWrapRef.current.contains(target)) {
        setOpenGroupDropdown(false);
      }
    };
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        setOpenOrderDropdown(false);
        setOpenGroupDropdown(false);
        setMobileSearchOpen(false);
      }
    };
    document.addEventListener('click', handleDocClick);
    document.addEventListener('keydown', handleKey);
    return () => {
      document.removeEventListener('click', handleDocClick);
      document.removeEventListener('keydown', handleKey);
    };
  }, [openOrderDropdown, openGroupDropdown]);

  // =========================
  // 滾動後 class 切換
  // =========================
  // const { dir: scrollDir, scrollY } = useScrollDirection({ threshold: 4, initial: 'up' });

  // /** 手機＋桌機共用 wrapper class */
  // const filterWrapperClass = mobileFilterOpen ? '' : 'd-md-block';

  // const filterPanelClassName = [
  //   filterWrapperClass,
  //   styles.filterPanel,
  //   mobileFilterOpen ? styles.filterPanelOpen : '',
  //   scrollDir === 'down'
  //     ? styles.filterPanelScrollDown
  //     : scrollY > 10
  //       ? styles.filterPanelScrollUp
  //       : '',
  // ]
  //   .filter(Boolean)
  //   .join(' ');

  // 1. 使用優化後的 Hook (建議 threshold 設 10 避免微震動)
  const { dir: scrollDir, scrollY } = useScrollDirection(10);

  // 2. 判斷是否處於「吸附狀態」
  // 只有當向下捲動一段距離後(例如 > 10px)，且方向為向上(up)時，才套用 ScrollUp class
  const isStickyUp = scrollDir === 'up' && scrollY > 10;
  const isStickyDown = scrollDir === 'down' && scrollY > 10;

  const filterPanelClassName = [
    styles.filterPanel,
    mobileFilterOpen ? styles.filterPanelOpen : '',
    isStickyDown ? styles.filterPanelScrollDown : '',
    isStickyUp ? styles.filterPanelScrollUp : '',
  ]
    .filter(Boolean)
    .join(' ');

  const safeOrderLabel = orderByLabel ?? orderByText(orderBy);

  // Tabs props（只有在 feat.tabs === true 時才會存在）
  const tab = feat.tabs ? (props as PropsWithTabs).tab : undefined;
  const onTab = feat.tabs ? (props as PropsWithTabs).onTab : undefined;

  const orderOptions = useMemo(() => {
    const base: OrderBy[] = ['letime', 'crtime', 'distance', 'article_num'];
    return allowCrtime ? base : base.filter((k) => k !== 'crtime');
  }, [allowCrtime]);

  return (
    <div className={`bg-white ${filterPanelClassName}`}>
      <div className={setClass}>
        {/* Tabs */}
        {feat.tabs && tab && onTab && (
          <section className="mb-5 d-flex align-items-center">
            <Tab isActive={tab === 'all'} onClick={() => onTab('all')}>
              全部
            </Tab>
            <Tab isActive={tab === 'branch'} onClick={() => onTab('branch')}>
              官方
            </Tab>
            <Tab isActive={tab === 'ar_space'} onClick={() => onTab('ar_space')}>
              個人
            </Tab>
          </section>
        )}

        <div className="position-relative">
          <div className="d-flex flex-wrap bd-highlight align-items-stretch gap-3 mb-0">
            {/* Search */}
            {feat.search && (
              <>
                {/* 桌機版搜尋 input */}
                <div className="position-relative flex-fill bd-highlight d-none d-md-block">
                  <input
                    className="form-control placeholder-md shadow-sm rounded-3 p-3"
                    type="text"
                    placeholder="請輸入關鍵字"
                    value={keyword}
                    onChange={(e) => onKeywordChange?.(e.target.value)}
                  />
                  <button
                    type="button"
                    className="position-absolute end-0 top-0 p-3"
                    aria-label={hasKeyword ? '清除關鍵字' : '搜尋'}
                    onClick={() => {
                      if (!onKeywordChange) return;
                      if (hasKeyword) onKeywordChange('');
                      else onMobileSearchConfirm?.();
                    }}
                  >
                    {hasKeyword ? <IconCancel /> : <IconSearch />}
                  </button>
                </div>

                {/* 手機版搜尋 input */}
                <div className="d-md-none order-3">
                  {!mobileSearchOpen && (
                    <button
                      type="button"
                      className="form-control shadow-sm rounded-3 p-3 w-auto d-flex align-items-center justify-content-center"
                      aria-label="搜尋"
                      onClick={onMobileSearchClick}
                    >
                      <IconSearch width={16} />
                    </button>
                  )}

                  {mobileSearchOpen && (
                    <div className="position-absolute top-0 end-0 w-100" style={{ zIndex: 20 }}>
                      <div className="position-relative">
                        <input
                          ref={mobileInputRef}
                          className=" form-control placeholder-sm shadow-sm rounded-3 p-2"
                          type="text"
                          placeholder="請輸入關鍵字"
                          value={keyword}
                          onChange={(e) => onKeywordChange?.(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              onMobileSearchConfirm?.();
                              setMobileSearchOpen(false);
                            }
                          }}
                        />
                        <button
                          type="button"
                          className="position-absolute top-0 end-0 p-2"
                          aria-label="關閉搜尋"
                          onClick={onMobileSearchClose}
                          title="關閉"
                        >
                          <IconCancel />
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </>
            )}

            {/* Order */}
            {feat.order && (
              <div
                className="position-relative flex-grow-1 flex-md-grow-0 bd-highlight"
                ref={orderWrapRef}
              >
                <button
                  type="button"
                  className="d-flex form-control shadow-sm rounded-3 p-2 p-md-3 align-items-center justify-content-between"
                  aria-haspopup="menu"
                  aria-expanded={openOrderDropdown}
                  onClick={() => setOpenOrderDropdown((v) => !v)}
                >
                  <span className="d-flex align-items-center">
                    <IconSortOutline className="me-1" />
                    {safeOrderLabel}
                  </span>
                  <span className="ms-2">▾</span>
                </button>

                {openOrderDropdown && (
                  <ul
                    role="menu"
                    className="dropdown-menu show w-100 mt-1"
                    style={{
                      position: 'absolute',
                      inset: 'auto auto 0 0',
                      transform: 'translate3d(0, 100%, 0)',
                    }}
                  >
                    {orderOptions.map((key) => (
                      <li key={key}>
                        <button
                          type="button"
                          role="menuitem"
                          className="dropdown-item d-flex justify-content-between"
                          onClick={() => {
                            if (key === 'distance') ensureUserLocation?.();
                            onOrder?.(key);
                            setOpenOrderDropdown(false);
                          }}
                        >
                          <span>{orderByText(key)}</span>
                          {orderBy === key && <span>✓</span>}
                        </button>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            )}

            {/* Category */}
            {feat.category && arspaceGroups.length > 0 && (
              <div
                className="position-relative flex-grow-1 flex-md-grow-0 bd-highlight"
                ref={groupWrapRef}
              >
                <button
                  type="button"
                  className="d-flex form-control shadow-sm rounded-3 p-2 p-md-3 align-items-center justify-content-between"
                  aria-haspopup="menu"
                  aria-expanded={openGroupDropdown}
                  onClick={() => setOpenGroupDropdown((v) => !v)}
                >
                  <span className="d-flex align-items-center">
                    <IconFilter width={16} className="me-2" />
                    {groupId === 'all'
                      ? '主題'
                      : (arspaceGroups.find((g) => String(g.id) === groupId)?.name ?? groupId)}
                  </span>
                  <span className="ms-2">▾</span>
                </button>

                {openGroupDropdown && (
                  <ul
                    role="menu"
                    className="dropdown-menu show w-100 mt-1"
                    style={{
                      position: 'absolute',
                      inset: 'auto auto 0 0',
                      transform: 'translate3d(0, 100%, 0)',
                    }}
                  >
                    <li>
                      <button
                        type="button"
                        role="menuitem"
                        className="dropdown-item d-flex justify-content-between"
                        onClick={() => {
                          onGroup?.('all');
                          setOpenGroupDropdown(false);
                        }}
                      >
                        <span>不限主題</span>
                        {groupId === 'all' && <span>✓</span>}
                      </button>
                    </li>

                    {arspaceGroups.map((g) => (
                      <li key={g.id}>
                        <button
                          type="button"
                          role="menuitem"
                          className="dropdown-item d-flex justify-content-between"
                          onClick={() => {
                            onGroup?.(String(g.id));
                            setOpenGroupDropdown(false);
                          }}
                        >
                          <span>{g.name}</span>
                          {groupId === String(g.id) && <span>✓</span>}
                        </button>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArSpaceFilterBar;
